import React from 'react';

const TestimonialCard = ({ name, company, quote }) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <div className="mb-4">
                {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400">★</span>
                ))}
            </div>
            <p className="text-gray-600 mb-6 italic">
                "{quote}"
            </p>
            <div>
                <p className="font-semibold">{name}</p>
                <p className="text-gray-600 text-sm">{company}</p>
            </div>
        </div>
    );
};

export default TestimonialCard;